import { render, staticRenderFns } from "./AdminPlansCard.vue?vue&type=template&id=640a4e7b"
import script from "./AdminPlansCard.vue?vue&type=script&lang=js"
export * from "./AdminPlansCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports